import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './store/reducers/rootReducer';
import firebase from 'firebase/app';
import { Provider } from 'react-redux';
import { reduxFirestore, getFirestore } from 'redux-firestore'
import { createFirestoreInstance } from 'redux-firestore'
import { getFirebase } from 'react-redux-firebase' 
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import thunk from 'redux-thunk'

import { useSelector } from 'react-redux'
import { isLoaded } from 'react-redux-firebase'

import FirebaseConfig from './config/FirebaseConfig';

import './App.css';

const store = createStore(rootReducer, compose(
    applyMiddleware(thunk.withExtraArgument({getFirebase, getFirestore})),
    reduxFirestore(FirebaseConfig),
));

function AuthIsLoaded({ children }) {
    const auth = useSelector(state => state.firebase.auth)
    if (!isLoaded(auth)) return <center><div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div></center>;
    return children
}

const firebaseReduxProps = {
    firebase,
    config: FirebaseConfig,
    dispatch: store.dispatch,
    createFirestoreInstance,
};

ReactDOM.render(
<Provider store={store}>
    <ReactReduxFirebaseProvider {...firebaseReduxProps}>
        <AuthIsLoaded>
            <App />
        </AuthIsLoaded>
    </ReactReduxFirebaseProvider>
</Provider>, document.getElementById('root'));

serviceWorker.unregister();
